// extracted by css-extract-rspack-plugin
export default {"root":"nydWhxEgSZcQ_2WM","trigger":"jLq0B1YwdEIgoevg","fieldMenu":"IB0X9iuuPbkDWgdG","valuePopover":"Dyzz9AQLoMZg3zYR","fieldLabel":"iLZPgwrtiAOZ1_WX"};